module.exports = __webpack_public_path__ + "img/lk.9d32b14c.svg";